import $ from 'jquery';

const $lang_switcher_list = $( '.language-switcher__options' );
const $lang_switcher = $( '.language-switcher' );
const $active_lang = $( '.language-switcher__active-lang' );

$lang_switcher.on( 'click', (event) => {
	changeSwitchState();
	event.stopPropagation();
} );

$lang_switcher_list.on( 'click', (event) => {
	event.stopPropagation();
} );

$( window ).on( 'click', (e) => {
	if ( $active_lang.hasClass( 'turn-arrow' ) ) {
		changeSwitchState( true );
	}
} );

const changeSwitchState = ( close = false ) => {
	if ( window.innerWidth >= 1024 ) {
		return;
	}

	if ( $active_lang.hasClass( 'turn-arrow' ) || close ) {
		$active_lang.removeClass( 'turn-arrow' );
		$lang_switcher_list.hide();
	} else {
		$active_lang.addClass( 'turn-arrow' );
		$lang_switcher_list.show();
	}
}

$( window ).on( "resize", function() {
	if ( window.innerWidth >= 1024 ) {
		$lang_switcher_list.css('display', '');
	}
} );